/**
 * Central definition of device type names (from device.type.split('_')[1]).
 * Used for alarm-deactivated icon override and temperature icon in IconsDeviceType.
 */
export const TEMPERATURE_SENSOR_TYPES = [
	'Milesight EM500-PT100',
	'Milesight EM300-TH',
	'Milesight EM320-TH',
	'Milesight TS30x Temperature',
	'Senlab TEM-LAB-14NS',
]

/**
 * @param {Object} device - Device object with type (e.g. "Vendor_Milesight EM300-TH").
 * @returns {Boolean} True if the device is a temperature sensor (alarm-deactivated icon applies).
 */
export const isTemperatureSensor = (device) => {
	const typeName = device.type && device.type.split('_')[1]
	return typeName ? TEMPERATURE_SENSOR_TYPES.includes(typeName) : false
}
